import React, { Component } from "react";


class Home extends Component {
  render() {
    return (
      <div>
        <div className="position-relative overflow-hidden p-3 p-md-4 text-center">
          <div className="col-md-5 p-lg-4 mx-auto hero">
            <div className="text-center p-1">
              <img src={require('../static/img/profile.png')} className="rounded" alt=".."/>
            </div>
            <h1 className="p-1 font-weight-light">
              Stefhan Campos
            </h1>
            <p className="leadfont-weight-normal">
                  I'm a Software Engineer and in my spare time I like to take random photos of things, places and sometimes people.
            </p>
           
          </div>
        </div>
      </div>
    )
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/Home.js